import React from 'react';

const LeadDetailReadOnlyContext = React.createContext(false);

export default LeadDetailReadOnlyContext;
